/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { accountActivation } from '../services';
import { useSnackbar } from 'notistack';

const Activate = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { code } = useParams();

  const getActivate = async () => {
    try {
      const payload = { code: code };
      const response = await accountActivation(payload);

      if (response.meta.total > 0) {
        enqueueSnackbar('Account successfully activated, please wait', {
          variant: 'success',
          preventDuplicate: true,
        });
        setTimeout(() => {
          navigate('/');
        }, 5000);
      }
    } catch (error) {
      enqueueSnackbar(
        error?.response?.data?.message ?? 'Something went wrong!',
        {
          variant: 'error',
          preventDuplicate: true,
        }
      );
    }
  };

  React.useEffect(() => {
    let mount = true;
    if (mount) {
      getActivate();
    }
    return () => {
      mount = false;
    };
  }, []);

  return (
    <div className="vh-100 w-100 d-flex align-items-center justify-content-center">
      <p>Process Activate</p>
    </div>
  );
};

export default Activate;
